import React from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

// Blurred teaser for exclusive analyst content the viewer has not unlocked.
export function ExclusiveGate({ preview, analystName, analystSlug, label = "content" }) {
  const to = analystSlug ? `/analyst/${analystSlug}` : "/analysts";
  return (
    <div data-testid="exclusive-gate" className="relative my-6 rounded-2xl border border-[#ccff00]/25 overflow-hidden">
      <div className="relative max-h-[220px] overflow-hidden p-6">
        <p className="text-zinc-300 leading-relaxed text-base whitespace-pre-line select-none blur-[6px]" aria-hidden="true">
          {preview || "This is exclusive analyst intelligence reserved for members with access to this analyst. Unlock the full thesis, data and interpretation layer."}
        </p>
        <div className="absolute inset-x-0 bottom-0 h-2/3 bg-gradient-to-t from-[#0a0a0a] via-[#0a0a0a]/90 to-transparent" />
      </div>
      <div className="relative z-10 -mt-16 pb-8 px-6 flex flex-col items-center text-center">
        <div className="w-12 h-12 rounded-full border border-[#ccff00]/40 grid place-items-center mb-3 glow-brand">
          <Lock className="w-5 h-5 text-[#ccff00]" />
        </div>
        <p className="font-mono-cl text-[11px] tracking-[0.24em] uppercase text-[#ccff00] mb-1">Exclusive Analyst {label}</p>
        <h3 className="font-display text-xl sm:text-2xl font-bold mb-2">
          Unlock the full {label}{analystName ? ` from ${analystName}` : ""}.
        </h3>
        <p className="text-zinc-400 text-sm max-w-md mb-5">
          This is reserved for members with access to this analyst via whitelist approval, an access code, or a subscription.
        </p>
        <Link
          to={to}
          data-testid="exclusive-gate-cta"
          className="px-6 py-3 rounded-full bg-[#ccff00] text-black font-semibold text-sm hover:brightness-110 transition-[filter]"
        >
          Get Access
        </Link>
      </div>
    </div>
  );
}

// Compact "Exclusive · Locked" pill for cards / list rows.
export function ExclusiveTag({ className = "" }) {
  return (
    <span data-testid="exclusive-tag" className={`inline-flex items-center gap-1.5 text-[11px] font-mono-cl tracking-[0.14em] uppercase text-[#ccff00] ${className}`}>
      <Lock className="w-3 h-3" /> Exclusive · Locked
    </span>
  );
}
